import Inquiry from './Inquiry.vue';

export default Inquiry;



// WEBPACK FOOTER //
// ./src/pages/inquiry/index.ts